<template>
  <template v-if="!initializing">
    <div v-if="$route.name === Landing">
      <router-view :key="$route.fullPath" />
    </div>

    <div v-else class="container-s">
      <TheHeader />
      <div class="content">
        <div class="wrapper">
          <LoadingAnimation v-if="storeGlobal.loadingGlobal || loadingStore.isLoading" />
          <router-view :key="$route.fullPath" />
				</div>
      </div>
      <TheFooter />
    </div>
    <WhatsAppWidget
      v-if="whatsapp"
      :phone="whatsapp"
      button_size="3rem" />
    <cookie-manager />
  </template>
</template>

<script setup>
  import TheHeader from '@/components/TheHeader';
  import TheFooter from '@/components/TheFooter';
  import CookieManager from '@/components/shared/CookieManager.vue';
  import LoadingAnimation from './components/shared/LoadingAnimation.vue';
  import { computed, onBeforeMount, ref } from 'vue';
  import { appGlobalStore } from '@/store_pinia/app';
  import { agenciaStoreModule } from '@/store_pinia/agencia';
  import { Landing } from '@/router/RouterNames';
  import { useUserStore } from '@/store_pinia/userStore';
  import { useLoadingStore } from '@/store_pinia/loadingStore';

  const storeGlobal = appGlobalStore();
  const loadingStore = useLoadingStore();
  const agenciaStore = agenciaStoreModule();
  const userStore = useUserStore();
  // This is needed because storeGlobal.loadingGlobal can not be used for showing the hole component
  // due to is changed in lots of inner components
  const initializing = ref(true);
  const whatsapp = computed(() => agenciaStore.getWhatsapp);

  async function init() {
    try {
      loadingStore.show();
      await userStore.obtieneInformacionUsuario();
    } catch (err) {
      console.error(err);
    } finally {
      initializing.value = false;
      loadingStore.hide();
    }
  }

  onBeforeMount(async () => await init());
</script>

<style lang="scss">
  @import '~@/assets/scss/main.scss';
  .container-s {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  .content {
    flex: 1;
  }
</style>
